import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-rodape-relatorio',
  templateUrl: './rodape-relatorio.component.html',
  styleUrls: ['./rodape-relatorio.component.scss']
})
export class RodapeRelatorioComponent {
  @Input() valorTotalDaFatura: any;
  @Input() tipoRelatorio: any;
}
